/**
 * Componentes básicos de interface do ERP Web. Desde a A0, os componentes vêm do pacote
 * compartilhado `@cafegestor/ui` (o mesmo do CaféGestor Vendedor); este arquivo mantém o
 * caminho de sempre (`@/components/ui`) para as telas do Web e acrescenta o `PageTitle`, que
 * usa o cabeçalho de página do Web (`patterns.tsx`).
 */
import type { ReactNode } from "react";
import { PageHeader } from "./patterns";

export {
  Alert,
  Badge,
  Button,
  Card,
  Field,
  Input,
  LinkButton,
  Select,
  Spinner,
  StatusBadge,
  Table,
  type Tone,
} from "@cafegestor/ui";

/** Cabeçalho de página (mesma assinatura de antes; o visual é o do PageHeader). */
export function PageTitle({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return <PageHeader title={title} description={description} actions={actions} />;
}
